
import * as api from "../constant/NewAPI";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import Utils from "../constant/Utils";
import Select from "react-select";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

// import * as api from "../constant/API";

const Product = () => {

    const [searchInput, setSearchInput] = useState("");
    const [productList, setProductList] = useState([]);
    const [sportList, setSportList] = useState([]);
    const [vendorList, setVendorList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [productName, setProductName] = useState("");
    const [sportId, setSportId] = useState("");
    const [productId, setProductId] = useState("");
    const [vendorId, setVendorId] = useState("");
    const [categoryId, setCategoryId] = useState("");
    const [productBrand, setProductBrand] = useState("");
    const [reorderlvl, setReorderLvl] = useState("");
    const [productDesc, setProductDesc] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const roleId = localStorage.getItem('RoleId');

    useEffect(() => {
        prdctList(null);
        if (roleId == '1' || roleId == '3') {
            sportsList();
            vendrList();
        }
    }, [])

    function prdctList(id: string | null) {
        let getProductList = api.ProductList;
        if (id) {
            getProductList += '/' + id;
        }
        fetch(getProductList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((prdctResponse) => prdctResponse.json())
            .then((prdctResult) => {
                if (prdctResult.code == 401) {
                    Utils.logoutUser();
                } else if (prdctResult.error == true) {
                    Swal.fire(prdctResult.message)
                } else {
                    if (id) {
                        setProductId(id)
                        setProductName(prdctResult.data[0].productName)
                        setSportId(prdctResult.data[0].productSportId)
                        setVendorId(prdctResult.data[0].productVendorId)
                        setCategoryId(prdctResult.data[0].productCategoryId)
                        setProductBrand(prdctResult.data[0].productBrand)
                        setReorderLvl(prdctResult.data[0].productReorderLevel)
                        setProductDesc(prdctResult.data[0].productDescription)
                    } else {
                        setProductList(prdctResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch product list", error);
            })
    }

    function sportsList() {
        const getSportsList = api.InventorySportList;
        fetch(getSportsList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((sprtResponse) => sprtResponse.json())
            .then((sprtResult) => {
                if (sprtResult.code == 401) {
                    Utils.logoutUser();
                }
                setSportList(sprtResult.data)
            })
    }

    function vendrList() {
        const getVendorList = api.VendorList;
        fetch(getVendorList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((vendResponse) => vendResponse.json())
            .then((vendResult) => {
                if (vendResult.code == 401) {
                    Utils.logoutUser();
                } else if (vendResult.error == true) {
                    Swal.fire(vendResult.message)
                } else {
                    setVendorList(vendResult.data)
                }
            })
            .catch((error) => {
                console.log("Failed to fetch vendor list", error);
            })
    }

    function setInitial() {
        setProductName('')
        setSportId('')
        setVendorId('')
        setCategoryId('')
        setProductBrand('')
        setReorderLvl('')
        setProductDesc('')
    }

    function editProduct(rowData) {
        prdctList(rowData.productId);
        catList(rowData.productSportId);
        setIsEdit(true)
        setOpenModal(true)
    }

    function catList(sprtid) {
        const categryLst = api.CategoryBySport + '/' + sprtid;
        fetch(categryLst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setCategoryList(result.data)
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire(result.message)
                }
            })
    }

    function saveProduct() {
        if (isEdit) {
            updateProduct()
        } else {
            const formData = new FormData();
            formData.append('productName', productName);
            formData.append('productSports', sportId);
            formData.append('productVendor', vendorId);
            formData.append('productCategory', categoryId);
            formData.append('productBrand', productBrand);
            formData.append('productDescription', productDesc);
            formData.append('productReorderLevel', reorderlvl);

            const productcreate = api.CreateProduct;
            fetch(productcreate, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    }
                })
        }
        setOpenModal(false)
    }

    function updateProduct() {
        const formData = new FormData();
        formData.append('productIdEdit', productId);
        formData.append('productNameEdit', productName);
        formData.append('productSportEdit', sportId);
        formData.append('productVendorEdit', vendorId);
        formData.append('productCategoryEdit', categoryId);
        formData.append('productBrandEdit', productBrand);
        formData.append('productDescriptionEdit', productDesc);
        formData.append('productReorderLevelEdit', reorderlvl);

        const productupdate = api.UpdateProduct;
        fetch(productupdate, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    const filteredData = productList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const nameRender = (rowData) => {
        return <span>{rowData.productName}</span>;
    };

    const sportRender = (rowData) => {
        return <span>{rowData.SportName}</span>;
    };

    const brandRender = (rowData) => {
        return <span>{rowData.productBrand}</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editProduct(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    return (
        <>
            <div className="row">
                <div className="col-sm-12">
                    <div className="court-tab-content">
                        <div className="card card-tableset">
                            <div className="card-body">
                                <div className="coache-head-blk">
                                    <div className="row align-items-center">
                                        {roleId == '1' || roleId == '3' ? (
                                            <>
                                                <div className="row col-lg-12">
                                                    <div className="save-changes">
                                                        <Button
                                                            className="btn-secondary text-uppercase"
                                                            variant="success"
                                                            onClick={() => { setOpenModal(true); setIsEdit(false); setInitial(); }}
                                                        >
                                                            <i className="fas fa-plus">Add Product</i>
                                                        </Button>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                        <div className="col-lg-6">
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="dataTables_filter">
                                                <label>
                                                    <input
                                                        type="text"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        placeholder="Search"
                                                        className="form-control"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50]}
                                                currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slNo"
                                                    header="Sl No"
                                                    body={slNoRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="productName"
                                                    header="Product Name"
                                                    body={nameRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="SportName"
                                                    header="Product Sport"
                                                    body={sportRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="productBrand"
                                                    header="Product Brand"
                                                    body={brandRender}
                                                ></Column>
                                                {(roleId == '1' || roleId == '3') ? (
                                                    <Column
                                                        className="text-link"
                                                        body={editDetails}
                                                    ></Column>
                                                ) : null}
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                <Modal
                    show={openModal}
                    size="xl"
                    centered
                    onHide={() => setOpenModal(false)}
                >
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 text-uppercase"><i className="fas fa-plus" />{isEdit ? "Edit " : "Add "}Product</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => setOpenModal(false)}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <div className="row">
                            <div className="col-lg-6 mb-10">
                                <label className="form-label">Product Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                    id="prdctNme"
                                    value={productName}
                                    onChange={(e) => setProductName(e.target.value)}
                                    placeholder="Product Name"
                                />
                            </div>
                            <div className="col-lg-6 mb-10">
                                <label className="form-label">Sport</label>
                                <Select
                                    value={sportList.find(sprt => sprt.sportId === sportId) ? {
                                        value: sportId,
                                        label: sportList.find(sprt => sprt.sportId === sportId).sportName
                                    } : null}
                                    onChange={(e) => {
                                        setSportId(e?.value)
                                        catList(e?.value)
                                    }}
                                    placeholder="Select a Sport"
                                    options={sportList.map(sprt => ({
                                        value: sprt.sportId,
                                        label: sprt.sportName
                                    }))}>
                                </Select>
                            </div>
                            <div className="col-lg-6 mb-10">
                                <label className="form-label">Vendor</label>
                                <Select
                                    value={vendorList.find(vndr => vndr.vendorId === vendorId) ? {
                                        value: vendorId,
                                        label: vendorList.find(vndr => vndr.vendorId === vendorId).vendorName
                                    } : null}
                                    onChange={(e) => {
                                        setVendorId(e?.value)
                                    }}
                                    options={vendorList.map(vndr => ({
                                        value: vndr.vendorId,
                                        label: vndr.vendorName
                                    }))}>
                                </Select>
                            </div>
                            <div className="col-lg-6 mb-10">
                                <label className="form-label">Category</label>
                                <Select
                                    value={Array.isArray(categoryList) ?
                                        categoryList.find(ctgry => ctgry.productCategoryId === categoryId) ? {
                                            value: categoryId,
                                            label: categoryList.find(ctgry => ctgry.productCategoryId === categoryId).productCategoryName
                                        } : null
                                        : null}
                                    onChange={(e) => {
                                        setCategoryId(e?.value)
                                    }}
                                    options={Array.isArray(categoryList) ? categoryList.map(ctgry => ({
                                        value: ctgry.productCategoryId,
                                        label: ctgry.productCategoryName
                                    }))
                                        : []}>
                                </Select>
                            </div>
                            <div className="col-lg-6 mb-10">
                                <label className="form-label">Brand Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                    id="brndNme"
                                    value={productBrand}
                                    onChange={(e) => setProductBrand(e.target.value)}
                                    placeholder="Product Brand"
                                />
                            </div>
                            <div className="col-lg-6 mb-10">
                                <label className="form-label">Re-order Level</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                    id="reordrlvl"
                                    value={reorderlvl}
                                    onChange={(e) => setReorderLvl(e.target.value)}
                                    placeholder="Re-order Level"
                                />
                            </div>
                            <div className="col-lg-6 mb-10">
                                <label className="form-label">Product Description</label>
                                <input
                                    type="textarea"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                    id="prdctdesc"
                                    value={productDesc}
                                    onChange={(e) => setProductDesc(e.target.value)}
                                    placeholder="Product Description"
                                />
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn-primary text-uppercase"
                            variant="success"
                            onClick={() => { saveProduct(); setOpenModal(false) }}
                            data-bs-dismiss="modal" aria-label="Close"
                        >
                            <b><i className="fas fa-save" />{isEdit ? " Update" : " Save"}</b>
                        </Button>
                    </ModalFooter>
                </Modal >
            }
        </>
    );
};

export default Product;